(() => {
  const STORAGE_DISMISSED = 'iamWelcomeOfferDismissedAt';
  const STORAGE_JOINED = 'iamWelcomeOfferJoinedAt';
  const DISMISS_TTL_MS = 14 * 24 * 60 * 60 * 1000;
  const SHOW_DELAY_MS = 9000;
  const SCROLL_TRIGGER_RATIO = 0.35;

  const now = () => Date.now();

  const getStoredTime = (key) => {
    try {
      const value = Number(window.localStorage.getItem(key));
      return Number.isFinite(value) ? value : 0;
    } catch {
      return 0;
    }
  };

  const setStoredTime = (key) => {
    try {
      window.localStorage.setItem(key, String(now()));
    } catch {
      // Ignore storage failures.
    }
  };

  const shouldSuppress = () => {
    const joinedAt = getStoredTime(STORAGE_JOINED);
    if (joinedAt) return true;

    const dismissedAt = getStoredTime(STORAGE_DISMISSED);
    return dismissedAt && now() - dismissedAt < DISMISS_TTL_MS;
  };

  const ageGateIsVisible = () => {
    const selectors = [
      '#av_submit_form',
      '#av_cancel_form',
      '.age-verifier',
      '.age-verification',
      '[id*="age" i][style*="display: block"]',
      '[class*="age" i][style*="display: block"]',
    ];

    return selectors.some((selector) => {
      try {
        return Array.from(document.querySelectorAll(selector)).some((element) => {
          if (!(element instanceof HTMLElement)) return false;
          const rect = element.getBoundingClientRect();
          const style = window.getComputedStyle(element);
          return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
        });
      } catch {
        return false;
      }
    });
  };

  const init = () => {
    const root = document.querySelector('[data-iam-welcome-slideup]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const close = root.querySelector('[data-iam-welcome-slideup-close]');
    const form = root.querySelector('[data-iam-klaviyo-form]');
    const forceOpen = new URLSearchParams(window.location.search).get('welcome_offer') === '1' || window.location.hash === '#welcome-offer';
    let hasShown = false;
    let delayTimer;

    const syncPreviewBarClearance = () => {
      const hasPreviewBar = !!document.querySelector('iframe[src*="shopifycloud/preview-bar"], iframe[src*="preview-bar"]');
      root.classList.toggle('has-preview-bar', hasPreviewBar);
    };

    syncPreviewBarClearance();
    window.setTimeout(syncPreviewBarClearance, 1200);
    window.setTimeout(syncPreviewBarClearance, 3000);

    const show = () => {
      if (hasShown) return;
      if (!forceOpen && shouldSuppress()) return;
      if (!forceOpen && ageGateIsVisible()) {
        window.setTimeout(show, 1200);
        return;
      }

      hasShown = true;
      root.hidden = false;
      window.IAMKlaviyoSubscribe?.initAllKlaviyoForms?.(root);
      window.requestAnimationFrame(() => root.classList.add('is-visible'));
    };

    const hide = ({ remember = true } = {}) => {
      root.classList.remove('is-visible');
      if (remember) setStoredTime(STORAGE_DISMISSED);
      window.setTimeout(() => {
        if (!root.classList.contains('is-visible')) root.hidden = true;
      }, 430);
    };

    close?.addEventListener('click', () => hide({ remember: true }));

    form?.addEventListener('submit', () => {
      const successObserver = new MutationObserver(() => {
        if (form.classList.contains('is-success')) {
          setStoredTime(STORAGE_JOINED);
          successObserver.disconnect();
        }
      });

      successObserver.observe(form, { attributes: true, attributeFilter: ['class'] });
      window.setTimeout(() => successObserver.disconnect(), 20000);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-visible')) hide({ remember: true });
    });

    if (forceOpen) {
      show();
      return;
    }

    if (shouldSuppress()) return;

    const onScroll = () => {
      const maxScrollable = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      const ratio = window.scrollY / maxScrollable;
      if (ratio >= SCROLL_TRIGGER_RATIO) {
        window.removeEventListener('scroll', onScroll);
        show();
      }
    };

    delayTimer = window.setTimeout(show, SHOW_DELAY_MS);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('beforeunload', () => window.clearTimeout(delayTimer), { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
